import { Action } from '@ngrx/store'

export const AUTHORIZED = '[Auth] Authorized'
export const UNAUTHORIZED = '[Auth] Unauthorized'

export class Authorized implements Action {
  readonly type = AUTHORIZED

  constructor() {}
}

export class Unauthorized implements Action {
  readonly type = UNAUTHORIZED

  constructor() {}
}

export type All
  = Authorized
  | Unauthorized



// WEBPACK FOOTER //
// ./src/actions/auth.ts